module.exports = __webpack_public_path__ + "img/9.e24969ef.jpg";